export const isIE = () => !!(window.document as any).documentMode;
